export default __webpack_public_path__ + "static/media/poolview.240c67f9.jpg";